var _excluded = ["performSearch"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import InfoIcon from '@domain-group/fe-co-icon/lib/js/info';
import { pushToDataLayer } from '@domain-group/fe-helper';
import ArrowDownIcon from '@domain-group/fe-co-icon/lib/js/chevron-down';
import AllhomesTabbedPanel from '@domain-group/fe-co-allhomes-tabbed-panel';
import { AgentEnquiryForm } from '@domain-group/fe-co-allhomes-enquiry-form';
import { EventBoundary, useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import AGENT_AGENCY_QUERY from '../utils/queries';
import { getLocalitiesDescription, getStatsTitle } from '../utils/localities';
import updateLocation from '../utils/update-location';
import AgencyResult from './agency-result';
import AgentResult from './agent-result';
import FilterPane from './filter-pane';
import Headers from './headers';
import SortDropdown from './sort-dropdown';
import { SORT_OPTIONS } from '../utils/sort-options';
import * as styles from './result-panel.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PAGE_SIZE = 100;
var ResultPanel = _ref => {
  var _props$localities;
  var performSearch = _ref.performSearch,
    props = _objectWithoutProperties(_ref, _excluded);
  var agentList = useRef([]);
  var agencyList = useRef([]);
  var totalRecordsAgent = useRef(0);
  var totalRecordsAgency = useRef(0);
  var _useState = useState(PAGE_SIZE),
    _useState2 = _slicedToArray(_useState, 2),
    pageSizeAgency = _useState2[0],
    setPageSizeAgency = _useState2[1];
  var _useState3 = useState(PAGE_SIZE),
    _useState4 = _slicedToArray(_useState3, 2),
    pageSizeAgent = _useState4[0],
    setPageSizeAgent = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    emailEnquiryModalOpen = _useState6[0],
    setEmailEnquiryModalOpen = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    enquiryLogoUrl = _useState8[0],
    setEnquiryLogoUrl = _useState8[1];
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    enquiryFormTitle = _useState10[0],
    setEnquiryFormTitle = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    enquiryClientType = _useState12[0],
    setEnquiryClientType = _useState12[1];
  var _useState13 = useState(),
    _useState14 = _slicedToArray(_useState13, 2),
    enquiryClientId = _useState14[0],
    setEnquiryClientId = _useState14[1];
  var _useState15 = useState(),
    _useState16 = _slicedToArray(_useState15, 2),
    enquiryClientName = _useState16[0],
    setEnquiryClientName = _useState16[1];
  var _useState17 = useState(),
    _useState18 = _slicedToArray(_useState17, 2),
    enquiryClientAgencyId = _useState18[0],
    setEnquiryAgencyId = _useState18[1];
  var _useState19 = useState(),
    _useState20 = _slicedToArray(_useState19, 2),
    enquiryClientAgencyName = _useState20[0],
    setEnquiryAgencyName = _useState20[1];
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var localitiesDescription = getLocalitiesDescription(props.localities);
  var locationSuffix = localitiesDescription && " in ".concat(localitiesDescription);
  var statsTitle = props.localities.length > 0 ? getStatsTitle(props.localities, props.sort) : '';
  var sendToDataLayer = (category, action, label) => {
    pushToDataLayer({
      event: 'GAevent',
      eventCategory: category,
      eventAction: action,
      eventLabel: label
    });
  };
  var localityInput = props.localities.map(_ref2 => {
    var id = _ref2.id,
      type = _ref2.type;
    return {
      id,
      type
    };
  });
  var result = useQuery(AGENT_AGENCY_QUERY, {
    variables: {
      localities: localityInput,
      agencyLimit: pageSizeAgency,
      agentLimit: pageSizeAgent,
      sort: SORT_OPTIONS[props.sort] && SORT_OPTIONS[props.sort].value
    }
  });
  var formatStat = stat => stat === 0 ? '-' : String(stat);
  if (result.data) {
    var _result$data = result.data,
      agencySearch = _result$data.agencySearch,
      agentSearch = _result$data.agentSearch;
    agencyList.current = agencySearch === null || agencySearch === void 0 ? void 0 : agencySearch.nodes.map(_ref3 => {
      var agency = _ref3.agency,
        stats = _ref3.stats;
      return {
        agencyId: Number(agency.agencyId),
        agencyName: agency.name,
        suburb: agency.address.division.name,
        postcode: agency.address.postcode,
        state: agency.address.state.abbreviation,
        childrenCount: agencySearch.count,
        agencyPhoto: agency.images.tinyLogo,
        address: agency.address.line1,
        phone: agency.phone,
        emailContactable: agency.isEmailContactable,
        agencyUrl: agency.profileUrl,
        sold: formatStat(stats.sold),
        soldAll: formatStat(agency.activity.stats.sold),
        sales: formatStat(stats.sales),
        salesAll: formatStat(agency.activity.stats.sales),
        rented: formatStat(stats.rented),
        rentedAll: formatStat(agency.activity.stats.rented),
        rentals: formatStat(stats.rentals),
        rentalsAll: formatStat(agency.activity.stats.rentals),
        developments: formatStat(stats.developments),
        developmentsAll: formatStat(agency.activity.stats.developments),
        soldDevelopments: formatStat(stats.soldDevelopments),
        soldDevelopmentsAll: formatStat(agency.activity.stats.soldDevelopments),
        daysOnMarket: formatStat(stats.saleStats.daysOnMarket),
        daysOnMarketAll: formatStat(agency.activity.stats.saleStats.daysOnMarket)
      };
    });
    totalRecordsAgency.current = agencySearch.total;
    agentList.current = agentSearch === null || agentSearch === void 0 ? void 0 : agentSearch.nodes.map(_ref4 => {
      var agent = _ref4.agent,
        stats = _ref4.stats;
      return {
        agencyId: Number(agent.agency.agencyId),
        agencyName: agent.agency.name,
        agentStaffId: Number(agent.agentId),
        agentStaffName: agent.name,
        state: agent.agency.address.state.abbreviation,
        agentStaffPhotoSmall: agent.profilePhoto,
        agencyPhoto: agent.agency.images.tinyLogo,
        phone: agent.phone,
        emailContactable: agent.isEmailContactable,
        agentUrl: agent.profileUrl,
        jobTitle: agent.jobTitle,
        sold: formatStat(stats.sold),
        soldAll: formatStat(agent.activity.stats.sold),
        sales: formatStat(stats.sales),
        salesAll: formatStat(agent.activity.stats.sales),
        rented: formatStat(stats.rented),
        rentedAll: formatStat(agent.activity.stats.rented),
        rentals: formatStat(stats.rentals),
        rentalsAll: formatStat(agent.activity.stats.rentals),
        developments: formatStat(stats.developments),
        developmentsAll: formatStat(agent.activity.stats.developments),
        soldDevelopments: formatStat(stats.soldDevelopments),
        soldDevelopmentsAll: formatStat(agent.activity.stats.soldDevelopments),
        daysOnMarket: formatStat(stats.saleStats.daysOnMarket),
        daysOnMarketAll: formatStat(agent.activity.stats.saleStats.daysOnMarket),
        highlightedAwards: agent.highlightedAwards
      };
    });
    totalRecordsAgent.current = agentSearch.total;
  }
  var showMoreAgents = event => {
    event.preventDefault();
    sendToDataLayer('Interaction', 'Agency Search Results', 'View More');
    setPageSizeAgent(pageSizeAgent + PAGE_SIZE);
  };
  var showMoreAgencies = event => {
    event.preventDefault();
    sendToDataLayer('Interaction', 'Agency Search Results', 'View More');
    setPageSizeAgency(pageSizeAgency + PAGE_SIZE);
  };
  var performLocationSearch = useCallback(evt => {
    performSearch(evt);
    sendEvent('refine-by-location');
  }, [performSearch, sendEvent]);
  var isLocationSelected = (_props$localities = props.localities) === null || _props$localities === void 0 ? void 0 : _props$localities.length;
  var noResults = totalRecordsAgency === 0 && totalRecordsAgent === 0;
  var launchEmailEnquiryModal = source => _ref5 => {
    var agentStaffId = _ref5.agentStaffId,
      agentStaffName = _ref5.agentStaffName,
      agencyId = _ref5.agencyId,
      agencyName = _ref5.agencyName,
      logo = _ref5.logo,
      title = _ref5.title;
    if (source === 'AGENCY') {
      sendToDataLayer('Interaction', 'Agency Search Results', 'Open Email Lightbox - Agency');
    } else {
      sendToDataLayer('Interaction', 'Agency Search Results', 'Open Email Lightbox - Agent');
    }
    setEnquiryClientType(source);
    setEnquiryLogoUrl(logo);
    setEnquiryFormTitle(title);
    setEnquiryClientId(agentStaffId);
    setEnquiryClientName(agentStaffName);
    setEnquiryAgencyId(agencyId);
    setEnquiryAgencyName(agencyName);
    setEmailEnquiryModalOpen(true);
  };
  var buildPanel = type => {
    var results;
    var paginatorText;
    var showPaginator = true;
    var paginatorCallback;
    switch (type) {
      case 'agency':
        results = ___EmotionJSX(AgencyResult, _extends({}, props, {
          agencyList: agencyList.current,
          totalRecordsAgency: totalRecordsAgency.current,
          totalRecordsAgent: totalRecordsAgent.current,
          active: type === props.tab,
          launchEmailEnquiryModal: launchEmailEnquiryModal('AGENCY'),
          statsTitle: statsTitle,
          sort: props.sort
        }));
        paginatorText = 'Show more agency results';
        paginatorCallback = showMoreAgencies;
        showPaginator = pageSizeAgency < totalRecordsAgency.current;
        break;
      default:
        results = ___EmotionJSX(AgentResult, _extends({}, props, {
          agentList: agentList.current,
          totalRecordsAgent: totalRecordsAgent.current,
          totalRecordsAgency: totalRecordsAgency.current,
          active: type === props.tab,
          launchEmailEnquiryModal: launchEmailEnquiryModal('AGENT'),
          statsTitle: statsTitle,
          sort: props.sort
        }));
        paginatorText = 'Show more agent results';
        paginatorCallback = showMoreAgents;
        showPaginator = pageSizeAgent < totalRecordsAgent.current;
    }
    return ___EmotionJSX("div", null, ___EmotionJSX("div", {
      css: styles.listingCountDisclaimer
    }, ___EmotionJSX(InfoIcon, {
      css: styles.listingCountDisclaimerIcon,
      size: "custom"
    }), ___EmotionJSX("span", {
      css: styles.listingCountDisclaimerLabel
    }, "Listing counts are for properties advertised on Allhomes in last 12 months")), results, showPaginator && ___EmotionJSX("div", {
      css: styles.paginationContainer
    }, ___EmotionJSX("button", {
      type: "button",
      onClick: paginatorCallback,
      css: styles.paginationButton
    }, ___EmotionJSX("div", {
      css: styles.paginationText
    }, paginatorText), ___EmotionJSX("div", {
      css: styles.paginationIcon
    }, ___EmotionJSX(ArrowDownIcon, {
      size: "small"
    })))));
  };
  var closeEmailEnquiryModal = () => {
    setEmailEnquiryModalOpen(false);
  };
  var submitEmailEnquiryForm = () => {
    if (enquiryClientType === 'AGENCY') {
      sendToDataLayer('Conversion', 'Email Enquiry - Find an Agent', "Agency Search Results - ".concat(enquiryClientName, " - ").concat(enquiryClientId));
    } else {
      sendToDataLayer('Conversion', 'Email Enquiry - Find an Agent', "Agent Search Results - ".concat(enquiryClientName, " - ").concat(enquiryClientId));
    }
  };
  var updateSelectedTabInUrl = tab => {
    if (tab.id === 'agent') {
      sendToDataLayer('Interaction', 'Agency Search Results', 'Agents Tab Click');
      sendEvent('tab-click', {
        tab: 'Agent'
      });
    } else {
      sendToDataLayer('Interaction', 'Agency Search Results', 'Agencies Tab Click');
      sendEvent('tab-click', {
        tab: 'Agency'
      });
    }
    updateLocation({
      tab: tab.id
    });
  };
  var renderEmailEnquiryModal = () => ___EmotionJSX(EventBoundary, {
    name: "".concat(enquiryClientType.toLowerCase(), "-enquiry-form"),
    data: {
      agentId: enquiryClientId,
      agentName: enquiryClientName,
      agencyId: enquiryClientAgencyId,
      agencyName: enquiryClientAgencyName
    }
  }, ___EmotionJSX(AgentEnquiryForm, {
    endpointUrl: props.enquiryEndpoint,
    closeCallback: closeEmailEnquiryModal,
    logoUrl: enquiryLogoUrl,
    formTitle: enquiryFormTitle,
    clientId: enquiryClientType === 'AGENCY' ? enquiryClientAgencyId : enquiryClientId,
    clientType: enquiryClientType,
    submitFormCallback: submitEmailEnquiryForm
  }));
  var mobile = props.media.mobile;
  var panels = [];
  if (totalRecordsAgency) {
    panels.push({
      tab: {
        id: 'agency',
        label: 'Agencies',
        totalCount: totalRecordsAgency.current
      },
      content: buildPanel('agency')
    });
  }
  if (totalRecordsAgent) {
    panels.push({
      tab: {
        id: 'agent',
        label: 'Agents',
        totalCount: totalRecordsAgent.current
      },
      content: buildPanel('agent')
    });
  }
  return ___EmotionJSX(EventBoundary, {
    name: "search-results"
  }, ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX(Headers, {
    localities: props.localities,
    searchResultsUrl: props.searchResultsUrl,
    totalAgencies: totalRecordsAgency.current,
    locationSuffix: locationSuffix
  }), ___EmotionJSX(FilterPane, {
    localities: props.localities,
    autocompleteUrl: props.autocompleteUrl,
    media: props.media,
    sort: props.sort,
    performSearch: performLocationSearch
  }), ___EmotionJSX("h1", {
    css: styles.tabTitle
  }, "".concat(totalRecordsAgency.current, " real estate agenc").concat(totalRecordsAgency.current === 1 ? 'y' : 'ies', " active").concat(locationSuffix)), props.tab === 'agency' && totalRecordsAgency.current === 0 && totalRecordsAgent.current !== 0 && ___EmotionJSX("div", {
    css: styles.errorMessage
  }, "It looks like there weren't any agents. The good news is we found these\n            agencies that might match your search."), ___EmotionJSX("div", {
    css: styles.tabContainer
  }, !mobile && ___EmotionJSX(SortDropdown, {
    media: props.media,
    value: props.sort,
    onChange: sort => {
      performSearch({
        localities: props.localities,
        sort
      });
    }
  }), isLocationSelected ? ___EmotionJSX(AllhomesTabbedPanel, {
    tabColour: styles.tabColour,
    tabCountColour: styles.tabCountColour,
    tabInactiveColour: styles.tabInactiveColour,
    tabBorderColour: styles.tabBorderColour,
    tabWrapper: ___EmotionJSX("div", {
      css: styles.tabbedPanelContainer
    }),
    activePanelIndex: props.tab === 'agency' ? 0 : 1,
    panels: panels,
    customTabs: mobile ? [___EmotionJSX(SortDropdown, {
      id: "mobile-sort-toggle",
      media: props.media,
      value: props.sort,
      onChange: sort => {
        performSearch({
          localities: props.localities,
          sort
        });
      }
    })] : undefined,
    onTabClick: updateSelectedTabInUrl,
    type: "css"
  }) : undefined, !isLocationSelected && ___EmotionJSX("div", null, "Add a location to search for agencies and agents"), noResults && isLocationSelected && ___EmotionJSX("h1", {
    css: styles.tabTitle
  }, "0 real estate agencies found", locationSuffix)), emailEnquiryModalOpen ? renderEmailEnquiryModal() : ''));
};
ResultPanel.propTypes = {
  localities: PropTypes.arrayOf(PropTypes.shape({})),
  tab: PropTypes.oneOf(['agency', 'agent']),
  query: PropTypes.string,
  sort: PropTypes.oneOf(['SOLD', 'SOLD_TOTAL', 'RENTED', 'RENTED_TOTAL', 'DEVELOPMENT', 'DEVELOPMENT_TOTAL']),
  performSearch: PropTypes.func,
  autocompleteUrl: PropTypes.string.isRequired,
  enquiryEndpoint: PropTypes.string.isRequired,
  searchResultsUrl: PropTypes.string,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  })
};
ResultPanel.defaultProps = {
  performSearch: () => {},
  localities: [],
  tab: 'agency',
  query: '',
  sort: 'SOLD',
  media: {},
  searchResultsUrl: ''
};
export default ResultPanel;